export const openInNewTab = (url: string): void => {
  setTimeout(() => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  });
};
